import { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { useAppSelector } from '../../store/hooks'
import { isAdminSelector } from '../../store/slices/roleSlice'
import { CustomerDetail } from '../../views/CustomerDetail'
import { Customers } from '../../views/Customers'
import { DayPlan } from '../../views/DayPlan'
import { InstructorAvailability } from '../../views/InstructorAvailability'
import { Instructors } from '../../views/Instructors'
import { InstructorSalary } from '../../views/InstructorSalary'
import { InstructorSalaryOverview } from '../../views/InstructorSalaryOverview'
import { NotFound } from '../../views/NotFound'
import { PosClosings } from '../../views/PosClosings'
import { Products } from '../../views/Products'
import { Receipts } from '../../views/Receipts'
import { Requests } from '../../views/Requests'
import { Settings } from '../../views/Settings'
import { Path } from './enums'

export const BaseRouter: FC = () => {
  const isAdmin = useAppSelector(isAdminSelector)

  return (
    <Routes>
      <Route path={Path.HOME} element={<Navigate to={Path.DAY_PLAN} replace />} />
      <Route path={Path.DAY_PLAN} element={<DayPlan />} />
      <Route path={Path.DAY_PLAN_LESSON} element={<DayPlan />} />
      <Route path={Path.REQUESTS} element={<Requests />} />
      <Route path={Path.CUSTOMERS} element={<Customers />} />
      <Route path={Path.CUSTOMERS_DRAWER} element={<Customers />} />
      <Route path={Path.CUSTOMER_DETAIL} element={<CustomerDetail />} />
      <Route path={Path.RECEIPTS} element={<Receipts />} />
      <Route path={Path.RECEIPTS_DETAIL} element={<Receipts />} />
      <Route path={Path.POS_CLOSINGS} element={<PosClosings />} />
      <Route path={Path.INSTRUCTORS} element={<Instructors />} />
      <Route path={Path.INSTRUCTOR_AVAILABILITY} element={<InstructorAvailability />} />
      {isAdmin && <Route path={Path.INSTRUCTOR_SALARY} element={<InstructorSalaryOverview />} />}
      {isAdmin && <Route path={Path.INSTRUCTOR_SALARY_DETAIL} element={<InstructorSalary />} />}
      <Route path={Path.PRODUCTS} element={<Products />} />
      {isAdmin && <Route path={Path.SETTINGS} element={<Settings />} />}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
